import React from 'react';
import PropTypes from 'prop-types';
import { checkRichTextHasContent } from 'design-comuni-plone-theme/helpers';
import { Container } from 'design-react-kit';
import { addAppURL, flattenToAppURL } from '@plone/volto/helpers';
import cx from 'classnames';
import { TextBlockView } from '@plone/volto-slate/blocks/Text';
import { defineMessages, useIntl } from 'react-intl';

const messages = defineMessages({
  noDataLabel: {
    id: 'noDataLabel',
    defaultMessage: 'No data to show. Please retry later.',
  },
});

const View = ({ data, id }) => {
  const intl = useIntl();

  const remoteData = data['resp-remote-counter'];
  const hasError = remoteData && remoteData.error;

  const replacePlaceholder = (v) => {
    if (remoteData) {
      return JSON.parse(
        JSON.stringify(v).replace('${date}', data['resp-remote-counter'].date),
      );
    }
    return v;
  };

  let body = '';
  if (!remoteData) {
    body = (
      <React.Fragment>
        <div className="counter">
          {intl.formatMessage(messages.noDataLabel)}
        </div>
      </React.Fragment>
    );
  } else {
    body = hasError ? (
      <React.Fragment>
        <div className="counter error">{remoteData.error}</div>
      </React.Fragment>
    ) : (
      <React.Fragment>
        {checkRichTextHasContent(data.title) && (
          <div className="title">
            <TextBlockView data={{ value: replacePlaceholder(data.title) }} />
          </div>
        )}

        {data['resp-remote-counter'] && (
          <div className="counter">{intl.formatNumber(remoteData.counter)}</div>
        )}
        {checkRichTextHasContent(data.text) && (
          <div className="text">
            <TextBlockView data={{ value: replacePlaceholder(data.text) }} />
          </div>
        )}
      </React.Fragment>
    );
  }

  return (
    <div className="block remote-counter">
      <div className="public-ui">
        <div
          className={cx('block-content', {
            'full-width': data.showFullWidth,
            'with-bg': data.background?.[0],
          })}
        >
          {data.background?.[0] && (
            <div
              className="background-image"
              style={{
                backgroundImage: `url(${
                  data.background[0]?.image_field
                    ? flattenToAppURL(
                        data.background[0]['@id'] +
                          '/' +
                          data.background[0].image_scales?.[
                            data.background[0].image_field
                          ][0].download,
                      )
                    : addAppURL(data.background[0]?.['@id'])
                })`,
              }}
            ></div>
          )}

          <Container className="px-md-4">{body}</Container>
        </div>
      </div>
    </div>
  );
};

/**
 * Property types.
 * @property {Object} propTypes Property types.
 * @static
 */
View.propTypes = {
  data: PropTypes.objectOf(PropTypes.any).isRequired,
  id: PropTypes.string.isRequired,
};

export default View;
